const CurrencyGetter = {
    currencies: state => state.currencies
};

export default CurrencyGetter;